import React from 'react';


const Text = ({children, ...props}) => {

  return (
    <p>{children}</p>
  )

};

export default Text;